/**
 * Apply COMPANY_PERMISSION rows (with optional description) to user login flags.
 */

const QC_LEGACY_PERMISSION_ID = 5;

const KNOWN_PERMISSION_DESCRIPTION_BY_ID = {
  1: 'planning',
  2: 'qc',
  3: 'inventory',
  4: 'engineering',
  5: 'accounting',
  6: 'inventory management',
  7: 'production reports',
  8: 'tooling',
  9: 'tpm',
};

function normalizeDescription(description) {
  return (description || '').trim().toLowerCase();
}

function parsePermissionId(permissionId) {
  if (permissionId == null || permissionId === '') return null;
  const n = typeof permissionId === 'string' ? parseInt(permissionId, 10) : permissionId;
  return Number.isNaN(n) ? null : n;
}

export function buildCompanyPermissionFlags(entries) {
  const flags = {
    allowPlanning: false,
    allowQC: false,
    allowInventory: false,
    allowEngineering: false,
    allowAccounting: false,
    allowTooling: false,
    allowTPM: false,
    allowSales: false,
    allowPurchasing: false,
  };

  if (!entries || !entries.length) return flags;

  entries.forEach((row) => {
    const permissionId = parsePermissionId(row.permission_id);
    const desc = normalizeDescription(row.description);

    if (desc === 'sales' || desc === 'purchasing') {
      flags[desc === 'sales' ? 'allowSales' : 'allowPurchasing'] = true;
      return;
    }

    if (permissionId === 1 || desc === 'planning' || desc === 'planning module') {
      flags.allowPlanning = true;
    }

    if (
      permissionId === 2 ||
      desc === 'qc' ||
      desc === 'qc module' ||
      (permissionId === QC_LEGACY_PERMISSION_ID &&
        (desc === 'qc module' || desc === 'qc' || desc.indexOf('qc') >= 0))
    ) {
      flags.allowQC = true;
    }

    if (
      permissionId === 3 ||
      permissionId === 6 ||
      desc === 'inventory' ||
      desc === 'inventory management' ||
      /^inventory(\s*management)?$/.test(desc)
    ) {
      flags.allowInventory = true;
    }

    if (permissionId === 4 || desc === 'engineering') {
      flags.allowEngineering = true;
    }

    if (
      (permissionId === 5 && desc !== 'qc module' && desc !== 'qc') ||
      desc === 'accounting'
    ) {
      flags.allowAccounting = true;
    }

    if (
      permissionId === 8 ||
      desc === 'tooling' ||
      /^tooling(\s*module)?$/.test(desc)
    ) {
      flags.allowTooling = true;
    }

    if (permissionId === 9 || desc === 'tpm') {
      flags.allowTPM = true;
    }
  });

  return flags;
}

export function applyCompanyPermissionsToUser(user, companyPermissionRows) {
  if (!user) return user;
  const rows = (companyPermissionRows || []).map((row) => {
    const permissionId = parsePermissionId(row.permission_id);
    const pid = permissionId;
    const desc =
      row.description ||
      (pid != null ? KNOWN_PERMISSION_DESCRIPTION_BY_ID[pid] : '') ||
      '';
    return { permission_id: permissionId, description: desc };
  });
  const flags = buildCompanyPermissionFlags(rows);
  return Object.assign({}, user, flags);
}

export function hasCompanyPermissionFlag(user, flagName) {
  if (!user) return false;
  return user[flagName] === true || user[flagName] === 1;
}
